import { Body2, Image, Overline } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';

import styles from './styles.css';

export type TBanksLogoListSize = 'S' | 'M';

const sizeClassName: Record<TBanksLogoListSize, string> = {
  S: 'root--size-s',
  M: 'root--size-m',
};

export type BankLogoListProps = {
  banks: string[];
  maxLogosShown?: number;
  size?: TBanksLogoListSize;
  withShadow?: boolean;
};

export const BanksLogoList: React.FC<BankLogoListProps> = ({
  banks,
  maxLogosShown = 5,
  size = 'M',
  withShadow = true,
}) => {
  const logoListToShow = banks.slice(0, maxLogosShown);
  const isLogosNeedToSlice = banks.length > maxLogosShown;

  const logoClassName = cn(styles['logo'], withShadow && styles['logo--shadow']);

  return (
    <div className={cn(styles['root'], styles[sizeClassName[size]])}>
      {logoListToShow.map((logo, index) => {
        return (
          <div key={index} className={logoClassName}>
            <Image src={logo} alt={''} borderRadius={'50%'} preloader />
          </div>
        );
      })}
      {isLogosNeedToSlice && (
        <div key={banks.length} className={logoClassName}>
          {size === 'S' ? (
            <Overline color={'text-secondary-default'}>+{banks.length - maxLogosShown}</Overline>
          ) : (
            <Body2 color={'text-secondary-default'}>+{banks.length - maxLogosShown}</Body2>
          )}
        </div>
      )}
    </div>
  );
};

BanksLogoList.displayName = 'BanksLogoList';
